package com.vamvisions.main.contact.data.remote

import com.vamvisions.main.api.ApiRoutes
import com.vamvisions.main.api.contact.ContactMessageAcceptedDto
import com.vamvisions.main.api.contact.ContactMessageRequestDto
import com.vamvisions.main.core.data.network.safeCall
import com.vamvisions.main.core.domain.DataError
import com.vamvisions.main.core.domain.Result
import io.ktor.client.HttpClient
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

/** The contact endpoint of the server API. */
class ContactApi(private val httpClient: HttpClient) {

    suspend fun send(request: ContactMessageRequestDto): Result<ContactMessageAcceptedDto, DataError.Network> =
        safeCall {
            httpClient.post(ApiRoutes.CONTACT_MESSAGES) {
                contentType(ContentType.Application.Json)
                setBody(request)
            }
        }
}
